// extracted by mini-css-extract-plugin
export var container = "dW_g";
export var fadeDiv = "dW_h1";
export var placeholderWrapper = "dW_s0";
export var video = "dW_s1";
export var videoWrapper = "dW_ls";
export var vimeoPlayer = "dW_s2";
export var wrapper = "dW_B";